import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { TranslateModule } from '@ngx-translate/core';
import { LocalDate } from '../../../store/models';
import { NOT_AVAILABLE } from '../../../common/constants';
import { PipesModule } from '../../../common/pipes/pipes.module';
import { DirectivesModule } from '../../../common/directives/directives.module';
import { DateWithTimezoneComponent } from '../../timezone/date-with-timezone.component';
@Component({
  selector: 'ui-info-field-item',
  imports: [
    CommonModule,
    MatFormFieldModule,
    TranslateModule,
    PipesModule,
    DirectivesModule,
    DateWithTimezoneComponent,
  ],
  templateUrl: './info-field-item.component.html',
  styleUrls: ['./info-field-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class InfoFieldItemComponent {
  @Input() label: string;
  @Input() flat = false;
  @Input() text?: string | number;
  @Input() localDate?: LocalDate;
  @Input() cropTextNeeded?: boolean = false;
  @Input() testId: string;
  @Input() displayedBottomMessage?: boolean = false;

  notAvailable = NOT_AVAILABLE;
}
